exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ipoint{padding:30px}.ipoint .remaining{font-size:24px;color:#0084ff;font-weight:600}.tabs-ipoint{text-align:center}.tabs-ipoint .order-tab-inline>li{padding:0 100px}@media (max-width:920px){.ipoint{padding:5px}.tabs-ipoint .order-tab-inline>li{padding:inherit}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16b3651c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profiler/iPoint.vue
// module id = 345
// module chunks = 0